import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './general-meter-water-meter-cold-lg.svg';
import md from './general-meter-water-meter-cold-md.svg';
import sm from './general-meter-water-meter-cold-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.GENERAL_METER_WATER_METER_COLD,
  label: 'Allgemeinzähler Kaltwasserzähler',
  shortLabel: 'All_Kaltw',
  icons: { sm, md, lg },
  component: component('general-meter-water-meter-cold/GeneralMeterColdWaterMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('general-meter-water-meter-cold/GeneralMeterColdWaterMeterAggregationWidget.vue'),
    props: { digitColor: 'BLUE' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
